/**
* Two Column Animated Wysiwyg JS
* -----------------------------------------------------------------------------
*
* All the JS for the Two Column Animated Wysiwyg component.
*/

/*
 * Example of importing modules if needed. Like for scroll magic / gsap
 */

// import {gsap} from 'gsap';
// import {ScrollTrigger} from 'gsap/ScrollTrigger.js';
( function( app ) {
  const COMPONENT = {

    className: 'two-column-animated-wysiwyg',
    selector: function() {
      return '.' + this.className;
    },
    // Fires after common.init, before .finalize and common.finalize
    init: function() {
      // gsap.registerPlugin( ScrollTrigger );

      // gsap.registerPlugin( ScrollTrigger );
      /*
       * Generates multiple customizable animated sines waves
       * using a canvas element. Supports retina displays and
       * limited mobile support
       *
       * I've created a seperate library based on this pen.
       * Check it out at https://github.com/isuttell/sine-waves
       */
      function SineWaveGenerator( options ) {
        $.extend( this, options || {} );

        // if ( !this.el ) {
        //   throw 'No Canvas Selected';
        // }
        this.ctx = this.el.getContext( '2d' );

        // if ( !this.waves.length ) {
        //   throw 'No waves specified';
        // }

        // Internal
        this._resizeWidth();
        window.addEventListener( 'resize', this._resizeWidth.bind( this ) );
        // User
        this.resizeEvent();
        window.addEventListener( 'resize', this.resizeEvent.bind( this ) );

        if ( typeof this.initialize === 'function' ) {
          this.initialize.call( this );
        }
        // Start the magic
        this.loop();
      }

      // Defaults
      SineWaveGenerator.prototype.speed = 5;
      SineWaveGenerator.prototype.amplitude = 100;
      SineWaveGenerator.prototype.wavelength = 100;
      SineWaveGenerator.prototype.segmentLength = 50;

      SineWaveGenerator.prototype.lineWidth = 2;
      SineWaveGenerator.prototype.strokeStyle = 'rgba(255, 255, 255)';

      SineWaveGenerator.prototype.resizeEvent = function() {};

      // fill the screen
      SineWaveGenerator.prototype._resizeWidth = function() {
        this.dpr = window.devicePixelRatio || 1;

        // this.width = this.el.width = window.innerWidth * this.dpr;
        // this.height = this.el.height = window.innerHeight * this.dpr;
        // this.el.style.width = window.innerWidth + 'px';
        // this.el.style.height = window.innerHeight + 'px';
        // console.log( this.el );
        this.width = this.el.width = $( this.el ).closest( '.sine-waves-container__two' ).width();
        this.height = this.el.height = $( this.el ).closest( '.sine-waves-container__two' ).outerHeight();
        this.el.style.width = $( this.el ).closest( '.sine-waves-container__two' ).width();
        this.el.style.height = $( this.el ).closest( '.sine-waves-container__two' ).outerHeight();

        this.waveWidth = this.width * 0.95;
        this.waveLeft = this.width * 0.025;
      };

      SineWaveGenerator.prototype.clear = function() {
        this.ctx.clearRect( 0, 0, this.width, this.height );
      };

      SineWaveGenerator.prototype.time = 0;

      SineWaveGenerator.prototype.update = function( time ) {
        this.time = this.time - 0.007;
        if ( typeof time === 'undefined' ) {
          time = this.time;
        }

        let index = -1;
        let length = this.waves.length;

        while ( ++index < length ) {
          const timeModifier = this.waves[index].timeModifier || 1;
          this.drawSine( time * timeModifier, this.waves[index] );
        }
        index = void 0;
        length = void 0;
      };

      // Constants
      const PI2 = Math.PI * 2;
      const HALFPI = Math.PI / 2;

      SineWaveGenerator.prototype.ease = function( percent, amplitude ) {
        return amplitude * ( Math.sin( percent * PI2 - HALFPI ) + 1 ) * 0.5;
      };

      SineWaveGenerator.prototype.drawSine = function( time, options ) {
        options = options || {};
        let amplitude = options.amplitude || this.amplitude;
        let wavelength = options.wavelength || this.wavelength;
        let lineWidth = options.lineWidth || this.lineWidth;
        let strokeStyle = options.strokeStyle || this.strokeStyle;
        let segmentLength = options.segmentLength || this.segmentLength;

        let x = time;
        let y = 0;
        let amp = this.amplitude;

        // Center the waves
        const yAxis = this.height / 2;

        // Styles
        this.ctx.lineWidth = lineWidth * this.dpr;
        this.ctx.strokeStyle = strokeStyle;
        this.ctx.lineCap = 'round';
        this.ctx.lineJoin = 'round';
        this.ctx.beginPath();

        // Starting Line
        this.ctx.moveTo( 0, yAxis );
        this.ctx.lineTo( this.waveLeft, yAxis );

        for ( let i = 0; i < this.waveWidth; i += segmentLength ) {
          x = ( time * this.speed ) + ( -yAxis + i ) / wavelength;
          y = Math.sin( x );

          // Easing
          amp = this.ease( i / this.waveWidth, amplitude );

          this.ctx.lineTo( i + this.waveLeft, amp * y + yAxis );

          amp = void 0;
        }

        // Ending Line
        this.ctx.lineTo( this.width, yAxis );

        // Stroke it
        this.ctx.stroke();

        // Clean up
        options = void 0;
        amplitude = void 0;
        wavelength = void 0;
        lineWidth = void 0;
        strokeStyle = void 0;
        segmentLength = void 0;
        x = void 0;
        y = void 0;
      };

      SineWaveGenerator.prototype.loop = function() {
        this.clear();
        this.update();

        window.requestAnimationFrame( this.loop.bind( this ) );
      };

      $( '.sine-waves__two' ).each( function() {
        const wave = this;
        new SineWaveGenerator( {
          // el: document.getElementById( 'waves' ),
          el: this,

          speed: 3,

          waves: [
            {
              timeModifier: 0.5,
              lineWidth: 1,
              amplitude: 50,
              wavelength: 150,
              segmentLength: 1,
            },
            {
              timeModifier: 0.25,
              lineWidth: 1,
              amplitude: 100,
              wavelength: 200,
              segmentLength: 1,
            },
          ],

          resizeEvent: function() {
            let gradient = this.ctx.createLinearGradient( 0, 0, this.width, 0 );
            const gradientTwo = this.ctx.createLinearGradient( 0, 0, this.width, 0 );
            // gradient.addColorStop( 0, 'rgba(0, 0, 0, 0)' );
            // gradient.addColorStop( 0.5, 'rgba(255, 255, 255, 0.5)' );
            // gradient.addColorStop( 1, 'rgba(0, 0, 0, 0)' );

            if ( $( wave ).hasClass( 'is-white' ) ) {
              gradient.addColorStop( 0, 'rgba(252, 249, 246, 0.3)' );
              gradient.addColorStop( 0.35, 'rgba(252, 249, 246, 0.3)' );
              gradient.addColorStop( 0.65, 'rgba(252, 249, 246, 0.3)' );
              gradient.addColorStop( 1, 'rgba(252, 249, 246, 0.3)' );
              gradientTwo.addColorStop( 0, 'rgba(252, 249, 246, 0.1)' );
              gradientTwo.addColorStop( 0.35, 'rgba(252, 249, 246, 0.1)' );
              gradientTwo.addColorStop( 0.65, 'rgba(252, 249, 246, 0.1)' );
              gradientTwo.addColorStop( 1, 'rgba(252, 249, 246, 0.1)' );
            } else {
              gradient.addColorStop( 0, 'rgba(255, 255, 255, 0)' );
              gradient.addColorStop( 0.35, 'rgba(0, 0, 0, 0.25)' );
              gradient.addColorStop( 0.65, 'rgba(0, 0, 0, 0.25)' );
              gradient.addColorStop( 1, 'rgba(255, 255, 255, 0)' );
            }


            let index = -1;
            let length = this.waves.length;
            while ( ++index < length ) {
              if ( index > 0 ) {
                this.waves[index].strokeStyle = gradientTwo;
              } else {
                this.waves[index].strokeStyle = gradient;
              }
            }

            // Clean Up
            index = void 0;
            length = void 0;
            gradient = void 0;
          },
        } );
      } );
    },
    finalize: function() {
    },
  };

  // Hooks the component into the app
  app.registerComponent( 'two-column-animated-wysiwyg', COMPONENT );
} )( app );
